import React, { Component } from 'react';

// 3rd party
import { TextField, SelectField } from 'redux-form-material-ui';
import { reduxForm, Field } from 'redux-form';
import MenuItem from 'material-ui/MenuItem';

// Components
import Toggle from '../../../../../../../components/Toggle';
import Button from '../../../../../../../components/Button';

// utils
import { required } from '../../../../../../../utils/validators';
import { states, statesToLabel } from '../../../../../../../utils/constants';

// CSS
import './styles.css';
import { Col, Container, Row } from './styles';

class NewNFForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPalletized: false,
      isDamaged: false,
      // If add another NF is clicked, this is set to true
      // Parent component handles the sidepanel state accordingly.
      shouldAddAnother: false,
    };
  }

  _addHiddenValues = values => {
    this.props.onSubmit({
      ...values,
      isDamaged: this.state.isDamaged,
      isPalletized: this.state.isPalletized,
      shouldAddAnother: this.state.shouldAddAnother,
    });

    // Reset state to initial state
    this.setState({
      shouldAddAnother: false,
      isDamaged: false,
      isPalletized: false,
    });

    // Reset form
    this.props.reset();
  };

  render() {
    const { handleSubmit, pristine, invalid, onCancel } = this.props;

    return (
      <form
        className="NewNFForm"
        onSubmit={handleSubmit(this._addHiddenValues)}
      >
        <div className="NewNFForm__content">
          <Container>
            <Row>
              <Col lg="10">
                <Row>
                  <Col lg="4">
                    <label className="NewNFForm__field" htmlFor="nf-number">
                      Numero NF
                      <Field
                        name="nf"
                        fullWidth
                        placeholder="Numero NF"
                        component={TextField}
                        validate={required}
                      />
                    </label>
                  </Col>
                  <Col lg="2">
                    <label className="NewNFForm__field" htmlFor="nf-number">
                      Série
                      <Field
                        name="nfGroup"
                        fullWidth
                        placeholder="Série"
                        component={TextField}
                        validate={required}
                      />
                    </label>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <label className="NewNFForm__field" htmlFor="receiver">
                      Destinatário
                      <Field
                        name="receiver"
                        fullWidth
                        placeholder="Destinatário"
                        component={TextField}
                        validate={required}
                      />
                    </label>
                  </Col>
                </Row>
                <Row>
                  <Col lg="8">
                    <label className="NewNFForm__field" htmlFor="city">
                      Cidade
                      <Field
                        name="cidade"
                        fullWidth
                        placeholder="Cidade"
                        component={TextField}
                        validate={required}
                      />
                    </label>
                  </Col>
                  <Col lg="4">
                    <label className="NewNFForm__field" htmlFor="uf">
                      UF
                      <Field
                        name="uf"
                        fullWidth
                        placeholder="UF"
                        component={SelectField}
                        validate={required}
                      >
                        {Object.keys(states).map(state => (
                          <MenuItem
                            key={state}
                            value={state}
                            primaryText={statesToLabel[states[state]]}
                          />
                        ))}
                      </Field>
                    </label>
                  </Col>
                </Row>
                <Row>
                  <Col xs6 lg="3">
                    <label className="NewNFForm__field" htmlFor="type">
                      Embalagem
                      <Field
                        name="type"
                        fullWidth
                        placeholder="Tipo"
                        component={SelectField}
                        validate={required}
                      >
                        {this.props.packagingTypes.map(type => (
                          <MenuItem
                            key={type.id}
                            value={type.id}
                            primaryText={type.value}
                          />
                        ))}
                      </Field>
                    </label>
                  </Col>
                  <Col xs6 lg="3">
                    <label className="NewNFForm__field" htmlFor="volumes">
                      Volumes (un)
                      <Field
                        name="volume"
                        fullWidth
                        placeholder="Volumes"
                        type="number"
                        props={{
                          step: '0.01',
                        }}
                        component={TextField}
                        validate={required}
                      />
                    </label>
                  </Col>
                  <Col xs6 lg="3">
                    <label className="NewNFForm__field" htmlFor="weight">
                      Peso (kgs)
                      <Field
                        name="weight"
                        fullWidth
                        placeholder="Peso"
                        type="number"
                        props={{
                          step: '0.01',
                        }}
                        component={TextField}
                        validate={required}
                      />
                    </label>
                  </Col>
                  <Col xs6 lg="3">
                    <label className="NewNFForm__field" htmlFor="value">
                      Valor (R$)
                      <Field
                        name="value"
                        fullWidth
                        type="number"
                        props={{
                          step: '0.01',
                        }}
                        placeholder="Valor"
                        component={TextField}
                        validate={required}
                      />
                    </label>
                  </Col>
                </Row>
                <Row>
                  <Col lg="2">
                    <label className="NewNFForm__field" htmlFor="damage">
                      Avaria
                      <Toggle
                        className="NewNFForm__field-toggle"
                        isChecked={this.state.isDamaged}
                        onChange={() => {
                          this.setState({
                            isDamaged: !this.state.isDamaged,
                          });
                        }}
                      />
                    </label>
                  </Col>
                  <Col lg="2">
                    <label className="NewNFForm__field" htmlFor="palletized">
                      Palletizado
                      <Toggle
                        className="NewNFForm__field-toggle"
                        isChecked={this.state.isPalletized}
                        onChange={() => {
                          this.setState({
                            isPalletized: !this.state.isPalletized,
                          });
                        }}
                      />
                    </label>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="NewNFForm__footer">
          <Button
            className="NewNFForm__footer-btn"
            skin="gray-light"
            text="Cancelar"
            onClick={e => {
              onCancel(e);
            }}
          />
          <Button
            className="NewNFForm__footer-btn"
            skin="primary"
            type="submit"
            text="Salvar e Adicionar Outra"
            onClick={() => {
              this.setState({
                shouldAddAnother: true,
              });
            }}
            disabled={pristine || invalid}
          />
          <Button
            className="NewNFForm__footer-btn"
            skin="primary"
            type="submit"
            text="Salvar e Concluir"
            onClick={() => {
              this.setState({
                shouldAddAnother: false,
              });
            }}
            disabled={pristine || invalid}
          />
        </div>
      </form>
    );
  }
}

export default reduxForm({ form: 'newNfForm' })(NewNFForm);
